import { Component, OnInit, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { DFormatos } from '@dian/api-diligenciamiento';
import { FechasService } from './../../../utils/fechas.service';

@Component({
  selector: 'app-formatos',
  templateUrl: './formatos.component.html',
  styleUrls: ['./formatos.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [
  	FechasService
  ]
})
export class FormatosComponent implements OnInit {

	@Input('grupo') grupo: number;
	@Input('busqueda') busqueda: string;
	@Input('list') listEntrada: DFormatos;	
	@Input('imgObjetos') imgObjetos: any;
  @Output() onSelectedItem: EventEmitter<any> = new EventEmitter<any>();
  @Output() mostrarElementos: EventEmitter<any> = new EventEmitter<any>();
	public listSalida: DFormatos;

  constructor(
  	private _fechaUtil: FechasService
  ) { 
  	this.listEntrada = new DFormatos();
  	this.listSalida = new DFormatos();
  }

  ngOnInit() {
  	setTimeout(() => {
  		this.filtrarLista()
  	}, 50);
  }

  private filtrarLista() {
  	for (let i in this.listEntrada.dFormatos) {
  		let item = this.listEntrada.dFormatos[i];
  		if (item.hasOwnProperty('ideGrupo') && item.ideGrupo === this.grupo) 
  			this.listSalida.dFormatos.push(item);  		
  	}

    if (!this.listSalida.dFormatos.length) this.mostrarElementos.emit(false);
    else {
      this.listSalida.dFormatos.sort((a: any, b: any) => {
        if (a['ideFormato'] < b['ideFormato']) {
          return -1;
        } else if (a['ideFormato'] > b['ideFormato']) {
          return 1;
        } else {
          return 0;
        }
      });
    }
  }

  public selectedItem(item: any) {
  	this.onSelectedItem.emit(item);  
  }

  /**
   * Funcion que realiza los calculos para indicar la alerta en la tarjeta
   * @param {Any} vencimiento
   * @return {String} color under of card selector
   */
  public verificarEstadoFormulario(vencimiento: any): string {
    // #e0bc0b - amarillo
    // #e05a0b - rojo
    let expiracion = new Date(vencimiento);
    let fechaActual = new Date();
    let diffDias = this._fechaUtil.obtenerDiferenciaDiasEntreDosFechas(expiracion, new Date());
    //let diffDias = expiracion.getDate() - fechaActual.getDate();
    //return "#d4d3d3";
    return (diffDias > 0 && diffDias <= 5) ? '#e0bc0b' : diffDias === 0 ? '#e05a0b' : '#ffffff';
  }

}



// WEBPACK FOOTER //
// D:/AngularProjects/Angular Projects/Formularios/src/app/resources/components/formatos/formatos.component.ts